import builder from '../builder';
import CommonFileEmptyAlternate from '../../streamline-icons/bold/common-file-empty-alternate.svg';

export default builder(
  'IconCommonFileEmptyAlternateBold',
  CommonFileEmptyAlternate,
);
